module.exports = __webpack_public_path__ + "img/recentBuy.da847334.png";